import { Theme } from "themes/light";
import { ButtonColor, ButtonVariant } from "./index";

interface MethodsParams {
  variant: ButtonVariant;
  theme: Theme;
  color: ButtonColor;
}

export const getDynamicDefaultStyle = ({ variant, theme, color }: MethodsParams) => {
  if (variant === "outlined") {
    return `
      background: transparent;
      border: 1px solid ${theme.colors.button[color].background};

      .button-label {
        color: ${theme.colors.button[color].background};
      }

      .button-icon {
        fill: ${theme.colors.button[color].content};
      }
    `;
  }

  if (variant === "link") {
    return `
      background: transparent;
      box-shadow: none;

      .button-label {
        color: ${theme.colors.button[color].background};
      }

      .button-icon {
        fill: ${theme.colors.button[color].content};
      }
    `;
  }

  return `
    background: ${theme.colors.button[color].background};

    .button-label {
      color: ${theme.colors.button[color].content};
    }

    .button-icon {
      fill: ${theme.colors.button[color].content};
    }
  `;
};

export const getDynamicHoverStyle = ({ variant, theme, color }: MethodsParams) => {
  if (variant === "outlined") {
    return `
      background-color: ${theme.colors.button[color].background};

      .button-label {
        color: ${theme.colors.button[color].content};
      }

      .button-icon {
        fill: ${theme.colors.button[color].content};
      }
    `;
  }

  if (variant === "link") {
    return `
      text-decoration: underline;
      box-shadow: none;
    `;
  }

  return `background-color: ${theme.colors.button[color].background}CC;`;
};
